
export const  getKey=()=>(
    Math.floor((Math.random() * 100000) + 1)
)